import React from 'react';
import { CheckCircle } from '@phosphor-icons/react';
export function HeroDashboard() {
  return <div className="relative w-full max-w-sm mx-auto lg:ml-auto" data-id="element-187">
      <div className="bg-[#161616] rounded-md border border-hairline-dark overflow-hidden" data-id="element-188">
        <div className="px-5 py-4 border-b border-hairline-dark" data-id="element-189">
          <div className="text-white font-heading font-bold text-lg" data-id="element-190">
            This month, with Knight
          </div>
        </div>

        <div className="p-5" data-id="element-191">
          <div className="space-y-4 mb-5" data-id="element-192">
            <div data-id="element-193">
              <div className="text-gray-500 font-mono text-[10px] uppercase tracking-wider mb-1" data-id="element-194">
                Payroll, on time
              </div>
              <div className="text-white font-mono font-semibold text-xl" data-id="element-195">
                100%
              </div>
            </div>
            <div data-id="element-196">
              <div className="text-gray-500 font-mono text-[10px] uppercase tracking-wider mb-1" data-id="element-197">
                BAS, lodged
              </div>
              <div className="text-white font-mono font-semibold text-xl" data-id="element-198">
                On schedule
              </div>
            </div>
            <div data-id="element-199">
              <div className="text-gray-500 font-mono text-[10px] uppercase tracking-wider mb-1" data-id="element-200">
                Books, current to
              </div>
              <div className="text-white font-mono font-semibold text-xl" data-id="element-201">
                This week
              </div>
            </div>
          </div>

          <div className="h-px bg-hairline-dark w-full mb-5" data-id="element-202"></div>

          <div className="space-y-2 mb-5" data-id="element-203">
            {['Australian-supervised', 'Essential Eight aligned', 'Fixed monthly fee'].map((item, i) => <div key={i} className="flex items-center text-xs text-gray-300 font-mono" data-id="element-204">
                <CheckCircle size={14} weight="regular" className="text-knight-orange mr-2 flex-shrink-0" data-id="element-205" />
                {item}
              </div>)}
          </div>

          <div className="font-mono text-[9px] text-gray-600 uppercase tracking-wider" data-id="element-206">
            / Illustrative. Actual reporting tailored to your business.
          </div>
        </div>
      </div>
    </div>;
}